// extracted by mini-css-extract-plugin
export default {"navBrand":"Header_navBrand__YjM-y","navLink":"Header_navLink__p50Zt"};